module.exports = __webpack_public_path__ + "img/nr_dark.ac55ec4a.svg";